// HealthAI Google Analytics 4 Utilities

// Get visitor statistics (client-side estimation)
export const getVisitorStats = () => {
  // This is a client-side estimation
  // Real visitor data comes from GA4 dashboard
  const stats = {
    totalVisitors: localStorage.getItem('healthai_visitor_count') || '0',
    todayVisitors: getSessionVisitors(),
    pageViews: localStorage.getItem('healthai_page_views') || '0',
    lastVisit: localStorage.getItem('healthai_last_visit') || new Date().toISOString()
  };
  
  return stats;
};

// Track session visitors
const getSessionVisitors = () => {
  const today = new Date().toDateString();
  const lastVisitDate = localStorage.getItem('healthai_visit_date');
  
  if (lastVisitDate !== today) {
    // New visitor today
    const todayVisitors = parseInt(localStorage.getItem('healthai_today_visitors') || '0') + 1;
    localStorage.setItem('healthai_today_visitors', todayVisitors.toString());
    localStorage.setItem('healthai_visit_date', today);
    
    // Increment total visitor count
    const totalVisitors = parseInt(localStorage.getItem('healthai_visitor_count') || '0') + 1;
    localStorage.setItem('healthai_visitor_count', totalVisitors.toString());
    
    return todayVisitors;
  }
  
  return parseInt(localStorage.getItem('healthai_today_visitors') || '1');
};

// Track page views
export const incrementPageViews = () => {
  const currentViews = parseInt(localStorage.getItem('healthai_page_views') || '0') + 1;
  localStorage.setItem('healthai_page_views', currentViews.toString());
  localStorage.setItem('healthai_last_visit', new Date().toISOString());
  return currentViews;
};

// Format visitor numbers for display
export const formatVisitorCount = (count) => {
  const num = parseInt(count) || 0;
  
  if (num >= 1000000) {
    return (num / 1000000).toFixed(1) + 'M';
  } else if (num >= 1000) {
    return (num / 1000).toFixed(1) + 'K';
  }
  
  return num.toString();
};

// Privacy-compliant visitor tracking
export const initializeVisitorTracking = () => {
  // Only track if user hasn't opted out
  if (!localStorage.getItem('healthai_analytics_opt_out')) {
    incrementPageViews();
    
    // Set first visit timestamp if not exists
    if (!localStorage.getItem('healthai_first_visit')) {
      localStorage.setItem('healthai_first_visit', new Date().toISOString());
    }
    
    return true;
  }
  
  return false;
};

// User opt-out functionality
export const optOutAnalytics = () => {
  localStorage.setItem('healthai_analytics_opt_out', 'true');
  // analytics disabled
};

export const optInAnalytics = () => {
  localStorage.removeItem('healthai_analytics_opt_out');
  // analytics enabled
};

export const isAnalyticsEnabled = () => {
  return !localStorage.getItem('healthai_analytics_opt_out');
};